module.exports = __webpack_public_path__ + "static/video/patrick_bernatchez.e9e20fa.webm";


//////////////////
// WEBPACK FOOTER
// ./src/commons/video/patrick_bernatchez.webm
// module id = 6s0A
// module chunks = 0